export { default as ChangePassword } from './ChangePasswordContainer';